import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { API } from '../../../API/API';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import ColEdit from '../../../components/ColEdit/ColEdit';
import UserNew from './New/UserNew';
import { useParams } from 'react-router-dom';

const User = (props) => {

    const params = useParams();

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    const [columns] = useState([{
        name: 'Нэвтрэх нэр',
        fieldName: 'userid',
        minColSize: 'mid',
        onRender: (item) => {
            return (
                <ColEdit onClick={() => onEditClick(item.userid)}>
                    {item.userid}
                </ColEdit>
            );
        }
    }, {
        name: 'Албан байгууллага',
        fieldName: 'companyname',
    }, {
        name: 'Үүрэг',
        fieldName: 'rolename'
    }, {
        name: 'Мэдээлэл',
        fieldName: 'datafilter'
    }, {
        name: 'Лиценз',
        fieldName: 'licensename'
    }, {
        name: 'Төлөв',
        fieldName: 'statusname'
    }]);

    const [id, setId] = useState();
    const [showNew, setShowNew] = useState(false);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        let tData = [];
        if (params?.empid > 0) {
            try {
                setLoading(true);
                await API.get("/api/shared/user-management/user/get_employee_user_list?empid=" + params?.empid).then(response => {
                    if (response.status === 200 && response.data.rettype === 0) {
                        tData = response.data.retdata;
                    }
                });
            } finally {
                setLoading(false);
            }
        }
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, [params?.empid]);

    const onNew = () => {
        setId();
        setShowNew(true);
    }

    const onEditClick = (p_id) => {
        setId(p_id);
        setShowNew(true);
    }

    const afterSaveNew = (p_close) => {
        setId();
        if (p_close) {
            setShowNew(false);
        }
        getData();
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onDismiss = () => {
        setId();
        setShowNew(false);
    }

    return (
        <div>
            <PageHeader
                title="Хэрэглэгчийн жагсаалт"
                buttonTitle="Хэрэглэгч нэмэх"
                onButtonClick={onNew}
                dataCount={data?.length}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                columns={columns}
                data={data}
                loading={loading}
            />
            <UserNew
                userid={id}
                empid={params?.empid}
                isOpen={showNew}
                onDismiss={onDismiss}
                afterSave={afterSaveNew} />
        </div>
    );
}

export default User;